import { Row, Col } from "react-bootstrap";
import InputForm from "../../../../components/inputs/InputForm";
import { Toggle } from "rsuite";

const DatesSwitchForm = ({
  values,
  touched,
  errors,
  onChange,
  handleBlur,
  setFieldValue,
}: {
  values: any;
  touched: any;
  errors: any;
  onChange: any;
  handleBlur: any;
  setFieldValue: any;
}) => {
  return (
    <div className="mt-3 mb-3">
      <Row className="d-flex justify-content-around align-items-center">
        <Col xs={12} md={3} className="d-flex justify-content-center">
          <div className="d-flex flex-column gap-3 justify-content-around">
            <div className="text-right">
              <span>Buscar por fecha ejecutoria</span>
            </div>
            <div className="d-flex justify-content-center">
              <Toggle
                checked={values.isExecutorDate}
                onChange={() =>
                  onChange({
                    target: {
                      name: "isExecutorDate",
                      value: !values.isExecutorDate,
                    },
                  })
                }
              />
            </div>
          </div>
        </Col>
        <Col xs={12} md={3}>
          <InputForm
            label="Fecha de inicio"
            name="startDate"
            type="date"
            value={values.startDate}
            touched={touched.startDate}
            error={errors.startDate}
            onChangeMethod={onChange}
            onBlurMethod={handleBlur}
          />
        </Col>
        <Col xs={12} md={3}>
          <InputForm
            label="Fecha de término"
            name="endDate"
            type="date"
            value={values.endDate}
            touched={touched.endDate}
            error={errors.endDate}
            onChangeMethod={onChange}
            onBlurMethod={handleBlur}
            disabled={values.startDate ? false : true}
            min={values.startDate}
          />
        </Col>
      </Row>
    </div>
  );
};

export default DatesSwitchForm;
